<template>
    <div class="bonus__check-items">
		<div class="bonus__check-item active">
			<svg class="bonus__check-item-icon"><use href="#svg-icon-checked"></use></svg>
			<span class="bonus__check-item-text">Игра:</span>
			<span class="bonus__check-item-value">{{ activation.promocode.freespin.game.name }}</span>
		</div>
		<div class="bonus__check-item active">
			<svg class="bonus__check-item-icon"><use href="#svg-icon-checked"></use></svg>
			<span class="bonus__check-item-text">Вагер:</span>
			<span class="bonus__check-item-value">x{{ activation.promocode.wager }}</span>
		</div>
		<div class="bonus__check-item active">
			<svg class="bonus__check-item-icon"><use href="#svg-icon-checked"></use></svg>
			<span class="bonus__check-item-text">Будет начислено отыгрыша:</span>
			<span class="bonus__check-item-value">Выигрыш  x{{ activation.promocode.wager }}</span>
		</div>
    </div>
</template>

<script>
    export default {
        props: {
            activation: {
                required: true,
                type: Object
            }
        }
    }
</script>
<style scoped>
.bonus-text {
    font-size: 13px;
    margin-bottom: 3px;
}
</style>